// useProjects — feeds the right-rail "Projects" glance card.
// Returns the project list from GET /projects. The glance shows name + open
// task count; it's a peek, never a browseable list.

import { useQuery } from '@tanstack/react-query';
import { listProjects } from '../api/client';
import type { ProjectItem } from '../api/types';

export function useProjects() {
  const { data, isLoading } = useQuery({
    queryKey: ['projects'],
    queryFn: listProjects,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  const projects: ProjectItem[] = data?.projects ?? [];
  return { projects, isLoading };
}
